import { TOTP } from "totp-generator"
import { Buffer } from 'buffer'


const getTOTP = (key: string, time: number) => {
  if (!key || !time) {
    return ''
  }
  const { otp, expires } = TOTP.generate(key, {
    digits: 6,
    algorithm: "SHA-1",
    period: 30,
    timestamp: time
  })
  // console.log('otp___code', otp)
  return { otp, expires }
}

const getLocalAlgInfo = () => {
  let algInfo = localStorage.getItem('algInfo')
  if (algInfo) {
    algInfo = JSON.parse(algInfo)
    return algInfo;
  } else {
    return {
      se: '3NNBISDSDPJYDE4JKSL5RLKV3KQSOTZO',
      sa: 'web_0',
    }
  }
}


const hmacSha256 = async (
  {
    seed,
    salt,
    body,
    encryptTime
  }: {
    seed: string,
    salt?: string,
    body: string,
    encryptTime?: string
  }
) => {
  const getUtf8Bytes = str =>
    new Uint8Array(
      [...unescape(encodeURIComponent(str))].map(c => c.charCodeAt(0))
    );

  const secret = salt ? `${seed}${salt}` : `${seed}`
  const text = `${body}${encryptTime}`
  const encoder = new TextEncoder();
  const algorithm = { name: "HMAC", hash: "SHA-256" };
  let key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secret),
    algorithm,
    true,
    ["sign", "verify"]
  );

  const signature = await crypto.subtle.sign(algorithm.name, key, encoder.encode(text));
  let digest = btoa(String.fromCharCode(...new Uint8Array(signature)));
  return digest
}

// 生成crypto.subtle secret key
const dynamicKey = async ({ seed, salt = 'web_0', time }: { seed: string, salt?: string, time: number }) => {

  if (!seed || !salt || !time) {
    throw new Error('seed, salt, time is required')
  }

  let totpCode = getTOTP(seed, time).otp;

  if (totpCode[0] == '0') {
    totpCode = totpCode.slice(1)
  }
  // encoder
  const encoder = new TextEncoder()
  const toHash = `${totpCode}${salt}${time}`
  const toHashData = encoder.encode(toHash);
  const hashBuffer = await crypto.subtle.digest("SHA-256", toHashData);

  const resultInt8Array = new Int8Array(hashBuffer);

  return resultInt8Array
}


const makeKey = async (keyBytes) => {
  // const aesKey = window.crypto.getRandomValues(new Uint8Array(16));
  //   // Buffer.from(keystr, "base64")
  // // console.log('aesKey', aesKey)
  const _key = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    {
      name: "AES-GCM",
      length: 256,
    }, true,
    ["encrypt", "decrypt"]
  );

  return _key
}


const decrypt = async (response: any) => {
  if (!response) {
    return null
  }

  const xTs = response.headers["x-ts"] || response.headers["X-Ts"]
  const encryptTime = parseInt(xTs)

  const responseData = response.body || response.data
  const ecryptStr = responseData?.data

  let ret = null

  if (ecryptStr
    // && response.config.url.includes('user/variety/list2')
  ) {
    const algInfo = getLocalAlgInfo()
    try {

      const keyBytes = await dynamicKey({
        seed: algInfo?.se,
        salt: algInfo?.sa,
        time: encryptTime
      })
      const secretKey = await makeKey(keyBytes)

      const toDecryptBuffer = Buffer.from(ecryptStr, 'base64')
      const iv = toDecryptBuffer.slice(0, 12);
      const toDecryptBufferActual = toDecryptBuffer.slice(12, toDecryptBuffer.length);

      const cleartext = await crypto.subtle.decrypt(
        {
          name: 'AES-GCM',
          iv: iv,
        },
        secretKey,
        toDecryptBufferActual
      );
      const data = new TextDecoder().decode(cleartext);

      ret = data
    } catch (e) {
      console.error('decrypt response error', e)

    }
  }
  return ret
}

const getHeaderXHS = async (config, encryptedBody, se, sa) => {
  // const { headers, url } = config
  // const arrNames = [
  //   'Lang',
  //   'Content-Type',
  //   // 'User-Agent',
  //   'X-App-Version',
  //   'X-Platform',
  //   'X-Device-Model',
  //   'X-Ts',
  //   'X-Time-Zone',
  //   'X-Device-Id',
  //   'X-UDID',
  //   'X-Token'
  // ]
  // let str = ''
  // const _arr = arrNames.map(name => {
  //   const _value = headers[name] ? headers[name] : 'null'
  //   const _str = `${name.toLowerCase()}:${_value}`
  //   return _str
  // })
  // str = _arr.join('\n')

  // str += `\n${url}`

  // if (encryptedBody) {
  //   str += `\n${JSON.stringify({data: encryptedBody})}`
  // }
  // str += `${headers['X-Ts']}`
  const str = getHeaderStr(config, encryptedBody)
  const secret = se + sa
  const encoder = new TextEncoder()
  const algorithm = { name: "HMAC", hash: "SHA-256" };
  let key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secret),
    algorithm,
    true,
    ["sign", "verify"]
  );
  // console.log('header sig str', str)
  const signature = await crypto.subtle.sign(algorithm.name, key, encoder.encode(str));
  let digest = btoa(String.fromCharCode(...new Uint8Array(signature)));
  return digest
}
const getHeaderStr = (config, encryptedBody) => {
  try {
    const { headers, url } = config
    const arrNames = [
      'Lang',
      'Content-Type',
      // 'User-Agent',
      'X-App-Version',
      'X-Platform',
      'X-Device-Model',
      'X-Ts',
      'X-Time-Zone',
      'X-Device-Id',
      'X-UDID',
      'X-Token'
    ]
    let str = ''
    const _arr = arrNames.map(name => {
      const _value = headers[name] ? headers[name] : 'null'
      const _str = `${name.toLowerCase()}:${_value}`
      return _str
    })
    str = _arr.join('\n')

    str += `\n${url}`

    if (encryptedBody) {
      str += `\n${JSON.stringify({ data: encryptedBody })}`
    }
    str += `${headers['X-Ts']}`
    return str
  } catch (error) {
    console.error('getHeaderStr error', error)
  }
  return ''

}
const encrypt = async (config: any) => {
  const data = config.data

  let dataJSON = JSON.stringify(data)
  const algInfo = getLocalAlgInfo()

  const keyBytes = await dynamicKey({
    seed: algInfo?.se,
    salt: algInfo?.sa,
    time: config.headers['X-Ts']
  })
  const secretKey = await makeKey(keyBytes)

  const encodedPlaintext = new TextEncoder().encode(dataJSON);
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const ciphertext = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv,
    },
    secretKey,
    encodedPlaintext
  );
  const ciphertResultArr = new Uint8Array(ciphertext);

  const resultArr = [...iv, ...ciphertResultArr]
  const resultStr = Buffer.from(resultArr).toString("base64")

  const signature = await hmacSha256({
    seed: algInfo.se,
    salt: algInfo?.sa,
    body: dataJSON,
    encryptTime: config.headers['X-Ts']
  })

  return {
    encriptStr: resultStr,
    signature: signature,
  }
}


const axioxRequestInterceptor = async (config: any) => {
  try {
    const algInfo = getLocalAlgInfo()
    let _se = '', _sa = ''
    if (config.url.includes('getAlgInfo')) {
      _se = 'YQNYPTETGQCF6UULOTXON4PWZUKPY4RN'
      _sa = ''
    } else {
      _se = algInfo?.se
      _sa = algInfo.sa
    }
    let headerXHS = ''
    if (!config.data) {
      headerXHS = await getHeaderXHS(config, '', _se, _sa) as string
      const str = `${getHeaderStr(config, "")}--${_se}--${_sa}`.replace(/\n/g, '/')
      config.headers["X-Header-Str"] = str
      // console.log('getHeaderStr', str)
      config.headers['X-HS'] = headerXHS
    } else {
      let { encriptStr, signature } = await encrypt(config)
      headerXHS = await getHeaderXHS(config, encriptStr, _se, _sa)
      const str = `${getHeaderStr(config, encriptStr)}/${_se}--${_sa}`.replace(/\n/g, '/')
      config.headers["X-Header-Str"] = str
      // console.log('getHeaderStr', str)
      config.headers['X-HS'] = headerXHS
      let configData = {}
      if (encriptStr) {
        configData = { data: encriptStr }
      }

      config.data = configData
      config.headers["X-Alg-Version"] = "1.0.0";
    }

  } catch (error) {
    console.error('axioxRequestInterceptor error', error)
  }
  return config
}

const addHeaderSignatureRequestInterceptor = async (config: any) => {
  const headers = config.headers
  // const fingerprintId = localStorage.getItem('fingerprintId')

  const arrNames = [
    'Lang',
    'Content-Type',
    // 'User-Agent',
    'X-App-Version',
    'X-Platform',
    'X-Device-Model',
    'X-Ts',
    'X-Time-Zone',
    'X-Device-Id',
    'X-UDID'
  ]
  let str = ''
  // console.log('headers key', Object.keys(headers))
  arrNames.forEach(name => {
    // console.log('!!!' + name, headers[name])
    const _str = headers[name] ? headers[name] : 'null'
    str += _str
  })

  str += headers['X-Ts']
  // console.log('str!!!!1', str + config.url)
  const secret = `${'YQNYPTETGQCF6UULOTXON4PWZUKPY4RN'}`
  const encoder = new TextEncoder()
  const algorithm = { name: "HMAC", hash: "SHA-256" };
  let key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secret),
    algorithm,
    true,
    ["sign", "verify"]
  );

  const signature = await crypto.subtle.sign(algorithm.name, key, encoder.encode(str));
  let digest = btoa(String.fromCharCode(...new Uint8Array(signature)));
  config.headers['X-HS'] = digest
  config.headers["X-Alg-Version"] = "1.0.0";
  return config
}

const axioxResponseInterceptor = async (response: any) => {
  // console.warn(response.config.url)
  const xTs = response.headers["x-ts"] || response.headers["X-Ts"]

  if (xTs) {

    const ecryptStr = response?.data?.data
    if (ecryptStr) {

      const decryptResult = await decrypt(response)

      response.data = JSON.parse(decryptResult)
    }
  }
  return response
}

export {
  getTOTP,
  decrypt,
  encrypt,

  axioxRequestInterceptor,
  axioxResponseInterceptor,
  addHeaderSignatureRequestInterceptor
}